import Vue from 'vue';
import VueI18n from 'vue-i18n';
import en from './en_US'
import es from './es_ES'

Vue.use(VueI18n);

export const i18n = new VueI18n({
  locale: 'en',
  messages: {
    en: {
      lang: en
    },
    es: {
      lang: es
    }
  }
});



// WEBPACK FOOTER //
// ./src/lang/i18n.js